import { useAppSelector } from "@/utils";

export function useIsSiteRequired() {
  const checks = useAppSelector((state) => state.user.checks);

  return checks?.isSiteRequired;
}
